import { Study } from '$app-web/types';

import { axios } from '../../axios';
import { Endpoints } from '../constant';

export async function fetchStudies() {
    try {
        const { status, data } = await axios.get<Array<Study>>(Endpoints.Participation);

        if (status === 200) {
            return data;
        }

        return [];
    } catch (error) {
        return [];
    }
}
